// Fascia della bottega nel carrello quando il cliente arriva dal negozio personale:
// il checkout resta quello di Rarifex, con il logo della bottega in evidenza.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { fetchPublicShop } from '../lib/shopsApi';
import { getShopSession, shopPaths } from '../lib/shopSession';
import { shopThemeStyle } from '../lib/shopThemes';
import { optimizeImageUrl } from '../utils/imageUrl';

export default function ShopCheckoutBanner() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const slug = getShopSession();
    if (!slug) return;
    let active = true;
    (async () => {
      const { data: crafter } = await supabase.from('profiles').select('id, slug, storefront_title, full_name, avatar_url').eq('slug', slug).maybeSingle();
      if (!crafter || !active) return;
      const shop = await fetchPublicShop(crafter.id);
      if (!shop.active || !active) return;
      setInfo({ slug, crafter, branding: shop.branding });
    })();
    return () => { active = false; };
  }, []);

  if (!info) return null;
  const name = info.crafter.storefront_title || info.crafter.full_name;
  const logo = info.branding.logo_url || info.crafter.avatar_url;
  return (
    <div className="mb-6 rounded-xl border bg-white p-3 md:p-4 flex flex-wrap items-center justify-between gap-3" style={shopThemeStyle(info.branding)} data-testid="shop-checkout-banner">
      <div className="flex items-center gap-3 min-w-0">
        {logo && <img src={optimizeImageUrl(logo, 120)} alt="" className="w-11 h-11 rounded-lg border object-contain bg-white p-0.5" />}
        <div className="min-w-0">
          <p className="text-xs text-slate-500">Stai acquistando da</p>
          <p className="font-semibold text-slate-900 truncate">{name}</p>
        </div>
        <span className="hidden sm:inline-flex items-center gap-1 text-xs text-slate-500 ml-2"><ShieldCheck className="w-4 h-4 text-shop-primary" /> Pagamento protetto da Rarifex</span>
      </div>
      <Link to={shopPaths(info.slug).home} className="inline-flex items-center gap-1 text-sm font-medium text-shop-primary hover:underline">
        <ArrowLeft className="w-4 h-4" /> Torna al negozio
      </Link>
    </div>
  );
}
